import axios from "axios";
import store from "@/store";

// FastAPI 서버 기본 설정 (환경 변수 사용)
const API_BASE_URL =
  process.env.VUE_APP_API_BASE_URL || "http://localhost:8080";
const API_TIMEOUT = 100000; // 30초 타임아웃

// Axios 인스턴스 생성
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  // headers: {
  //   'Content-Type': 'application/json',
  // }
});

// 요청 인터셉터
apiClient.interceptors.request.use(
  (config) => {
    // Accept-Language 헤더 추가
    const currentLanguage = store.getters.currentLanguage;
    config.headers["Accept-Language"] = currentLanguage;

    console.log(
      `🚀 API 요청: ${config.method?.toUpperCase()} ${
        config.url
      } [lang: ${currentLanguage}]`,
    );
    return config;
  },
  (error) => {
    console.error("❌ API 요청 오류:", error);
    return Promise.reject(error);
  },
);

// 응답 인터셉터 - 응답 후 로깅 및 에러 처리
apiClient.interceptors.response.use(
  (response) => {
    console.log(
      `✅ API 응답: ${response.config.method?.toUpperCase()} ${
        response.config.url
      } - ${response.status}`,
    );
    return response;
  },
  (error) => {
    console.error("❌ API 응답 오류:", error);

    if (error.code === "ECONNABORTED") {
      console.error("⏰ API 요청 타임아웃");
    } else if (error.response) {
      console.error(
        `🔴 서버 오류: ${error.response.status} - ${error.response.statusText}`,
      );
    } else if (error.request) {
      console.error("🔌 네트워크 연결 오류");
    }

    return Promise.reject(error);
  },
);

export class ApiService {
  // 서버 연결 상태 확인
  static async healthCheck() {
    try {
      const response = await apiClient.get("/health");
      return response.data;
    } catch (error) {
      throw new Error("FastAPI 서버에 연결할 수 없습니다.");
    }
  }

  static async loadFile(fileKey) {
    const response = await apiClient.get("/load_file", {
      params: { fileKey },
    });
    return response.data;
  }

static async getDriveList(page, parent, driverKind, userNo) {
  const response = await apiClient.get("/drive_list", {
    params: {
      page,
      parent,
      driver_kind: driverKind,
      user_no: userNo
    }
  });

  return response.data;  // ✅ 이게 맞음
}




  static async calibrateROI(image) {
    const res = await apiClient.post("/calibrate-roi", {
      image,
    });
    return res.data;
  }

  static async captureFingerTip(image, roiSize, H_mat) {
    const res = await apiClient.post("/finger-tip", {
      image,
      roiSize,
      H_mat, // message 대신 H_mat로 전달
    });
    return res.data;
  }

  static async url_image_base64(imageAttachNo) {
    const response = await apiClient.get("/get_image_base64", {
      params: { no: imageAttachNo },
    });
    return response.data.base64; // ★ base64 문자열만 리턴
  }

  // 이미지 업로드
  static async uploadImage(imageFile) {
    try {
      const formData = new FormData();
      formData.append("file", imageFile);

      const response = await apiClient.post("/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      throw new Error("이미지 업로드에 실패했습니다.");
    }
  }

  // 이미지 분석 요청
  static async analyzeImage(base64DataUrl, ours_or_baseline) {
    try {
      // base64에서 실제 데이터 부분만 추출
      const base64 = base64DataUrl.split(",")[1];
      const mime = base64DataUrl.match(/data:(.*);base64/)[1];

      // base64 → Blob → File 변환
      const byteChars = atob(base64);
      const byteNumbers = new Array(byteChars.length)
        .fill(0)
        .map((_, i) => byteChars.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mime });
      const file = new File([blob], "image.png", { type: mime });
      const userid = localStorage.getItem("userInfo");

      // FormData에 File 추가
      const formData = new FormData();
      formData.append("file", file); // FastAPI UploadFile = File(...)에 맞춤
      formData.append("ours_or_baseline", ours_or_baseline); // 문자열로!
      formData.append("userid", userid); // 문자열로!
      console.log(
        "ours_or_baselineours_or_baselineours_or_baseline",
        formData.get("ours_or_baseline"),
      );
      const response = await apiClient.post("/sa2va", formData);
      console.log("이미지 분석 결과:", response);
      // 구조분해 할당
      const { resized_list, uuid } = response.data;

      // 이제 각각 사용 가능
      console.log("UUID:", uuid);
      console.log("Resized List:", response.data);

      // 새 uuid 저장
      if (localStorage.getItem("uuid")) {
        localStorage.removeItem("uuid"); // 기존 uuid 삭제
      }
      localStorage.setItem("uuid", uuid);

      return response.data;
    } catch (error) {
      console.error("🔴 상태 코드:", error.response?.status);
      console.error("🔴 오류 내용:", error.response?.data);
      console.error("🔴 전체 응답:", error.response);
      throw new Error("이미지 분석에 실패했습니다.");
    }
  }

  static async analyzeText(DataText, ours_or_baseline) {
    try {
      const userid = localStorage.getItem("userInfo");
      const formData = new FormData();
      formData.append("DataText", DataText); // FastAPI UploadFile = File(...)에 맞춤
      formData.append("ours_or_baseline", ours_or_baseline); // 문자열로!
      formData.append("userid", userid); // 문자열로!
      console.log(
        "ours_or_baselineours_or_baselineours_or_baseline",
        formData.get("ours_or_baseline"),
      );
      const response = await apiClient.post("/TextTactile", formData);
      const { resized_list, uuid } = response.data;
      console.log("이미지 분석 결과:", response);
      // 구조분해 할당

      // 이제 각각 사용 가능
      console.log("UUID:", uuid);
      console.log("Resized List:", response.data);

      // 새 uuid 저장
      if (localStorage.getItem("uuid")) {
        localStorage.removeItem("uuid"); // 기존 uuid 삭제
      }
      localStorage.setItem("uuid", uuid);

      return response.data;
    } catch (error) {
      console.error("🔴 상태 코드:", error.response?.status);
      console.error("🔴 오류 내용:", error.response?.data);
      console.error("🔴 전체 응답:", error.response);
      throw new Error("이미지 분석에 실패했습니다.");
    }
  }

  static async analyzeExcel(selectedFile, text, ours_or_baseline) {
    try {
      const userid = localStorage.getItem("userInfo");
      const formData = new FormData();
      console.log(selectedFile);
      console.log(this.selectedFile instanceof File);
      console.log(text);
      console.log(ours_or_baseline);
      formData.append("selectedFile", selectedFile); // FastAPI UploadFile = File(...)에 맞춤
      formData.append("ours_or_baseline", ours_or_baseline); // 문자열로!
      formData.append("userid", userid); // 문자열로!
      formData.append("text", text);
      const response = await apiClient.post("/excel", formData);
      const { resized_list, uuid } = response.data;
      console.log("이미지 분석 결과:", response);
      // 구조분해 할당

      // 이제 각각 사용 가능
      console.log("UUID:", uuid);
      console.log("Resized List:", response.data);

      // 새 uuid 저장
      if (localStorage.getItem("uuid")) {
        localStorage.removeItem("uuid"); // 기존 uuid 삭제
      }
      localStorage.setItem("uuid", uuid);

      return response.data;
    } catch (error) {
      console.error("🔴 상태 코드:", error.response?.status);
      console.error("🔴 오류 내용:", error.response?.data);
      console.error("🔴 전체 응답:", error.response);
      throw new Error("이미지 분석에 실패했습니다.");
    }
  }

  static async analyzeQA(DataText, ours_or_baseline) {
    try {
      const userid = localStorage.getItem("userInfo");
      const formData = new FormData();
      formData.append("DataText", DataText); // FastAPI UploadFile = File(...)에 맞춤
      formData.append("ours_or_baseline", ours_or_baseline); // 문자열로!
      formData.append("userid", userid); // 문자열로!
      console.log(
        "ours_or_baselineours_or_baselineours_or_baseline",
        formData.get("ours_or_baseline"),
      );
      const response = await apiClient.post("/QArag", formData);
      const { resized_list, uuid } = response.data;
      console.log("이미지 분석 결과:", response);
      // 구조분해 할당

      // 이제 각각 사용 가능
      console.log("UUID:", uuid);
      const { answer, DS, type, legend } = response.data;
      console.log("Answer:", answer);

      // 새 uuid 저장
      if (localStorage.getItem("uuid")) {
        localStorage.removeItem("uuid"); // 기존 uuid 삭제
      }
      localStorage.setItem("uuid", uuid);

      return response.data;
    } catch (error) {
      console.error("🔴 상태 코드:", error.response?.status);
      console.error("🔴 오류 내용:", error.response?.data);
      console.error("🔴 전체 응답:", error.response);
      throw new Error("이미지 분석에 실패했습니다.");
    }
  }

  // 이미지 설명 요청
  static async Image_Descriptor(imageFile) {
    const base64 = imageFile.split(",")[1];
    const mime = imageFile.match(/data:(.*);base64/)[1];

    // base64 → Blob → File 변환
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length)
      .fill(0)
      .map((_, i) => byteChars.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mime });
    const file = new File([blob], "image.png", { type: mime });
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await apiClient.post("/imageDS", formData);
      console.log(response.data);
      return response.data;
    } catch (error) {
      throw new Error("이미지 분석에 실패했습니다.");
    }
  }

  // 웹캠 이미지 설명 요청
  static async webcam(imageFile) {
    const base64 = imageFile.split(",")[1];
    const mime = imageFile.match(/data:(.*);base64/)[1];

    const cachedUuid = localStorage.getItem("uuid");
    // base64 → Blob → File 변환
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length)
      .fill(0)
      .map((_, i) => byteChars.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mime });
    const file = new File([blob], "image.png", { type: mime });
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("request_id", cachedUuid);
      const response = await apiClient.post("/F3", formData);
      console.log(response.data);
      return response.data;
    } catch (error) {
      throw new Error("이미지 분석에 실패했습니다.");
    }
  }

  static async sendFingerTip(tip, roiSize = null, messege) {
    console.log("raw tip input:", tip);
    console.log("raw roiSize input:", roiSize);
    console.log("messege:", messege);

    // 1) tip → x,y 추출
    const [xRaw, yRaw] = Array.isArray(tip) ? tip : [tip?.x, tip?.y];

    if (!Number.isFinite(xRaw) || !Number.isFinite(yRaw)) {
      throw new Error("잘못된 좌표");
    }

    const x = Math.round(xRaw);
    const y = Math.round(yRaw);

    // 2) ROI size 항상 {roi_w, roi_h} 형태로 강제 변환
    const roi = (() => {
      // 배열 [w, h]
      if (Array.isArray(roiSize) && roiSize.length === 2) {
        return { roi_w: roiSize[0], roi_h: roiSize[1] };
      }
      // 객체 {roi_w, roi_h}
      if (roiSize?.roi_w && roiSize?.roi_h) {
        return { roi_w: roiSize.roi_w, roi_h: roiSize.roi_h };
      }
      // 둘 다 아니면 오류
      throw new Error("ROI 크기 없음");
    })();

    // 3) 서버가 요구하는 구조로 payload 생성
    const payload = {
      x,
      y,
      roi_w: roi.roi_w,
      roi_h: roi.roi_h,
      tip_roi: [xRaw, yRaw], // 보조 정보
    };

    console.log("📦 Payload 최종:", payload);

    const uuid = localStorage.getItem("uuid");

    const formData = new FormData();
    formData.append("request_id", uuid);
    formData.append("payload", JSON.stringify(payload));
    formData.append("messege", messege);

    // 4) 서버 전송
    const res = await apiClient.post("/F3", formData);
    return res.data;
  }

  // AI 채팅 요청
  static async sendChatMessage(imageFile, message) {
    const formData = new FormData();
    const cachedUuid = localStorage.getItem("uuid");

    formData.append("message", message);
    formData.append("request_id", cachedUuid);
    // console.log(formData.get('message'));
    if (imageFile && typeof imageFile === "string") {
      const base64Split = imageFile.split(",");
      if (base64Split.length < 2) {
        throw new Error("이미지 데이터 형식이 올바르지 않습니다.");
      }
      const base64 = base64Split[1];
      const match = imageFile.match(/data:(.*);base64/);
      if (!match) {
        throw new Error("이미지 데이터 형식이 올바르지 않습니다.");
      }
      const mime = match[1];

      const byteChars = atob(base64);
      const byteNumbers = new Array(byteChars.length)
        .fill(0)
        .map((_, i) => byteChars.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mime });
      const file = new File([blob], "image.png", { type: mime });

      formData.append("file", file);
      formData.append("state", "img"); // 이미지 포함
    } else {
      formData.append("state", "text"); // 이미지 없음
      formData.append("file", "");
    }

    try {
      const response = await apiClient.post("/chat", formData);
      console.log("/chat 결과", response.data);
      return response.data;
    } catch (error) {
      throw new Error("AI 채팅 요청에 실패했습니다.");
    }
  }

  // 타이머 결과 전송
  static async sendTimer(payload) {
    try {
      // const payload = {
      //   timeSpent: seconds,
      //   request_id: localStorage.getItem('uuid') || null,
      // }

      const requestData = {
        request_id: payload.request_id,
        step_name: payload.step_name,
        elapsed_time: payload.timeSpent,
      };
      const response = await apiClient.post("/timer", requestData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("타이머 전송 오류:", error);
      throw new Error("타이머 결과 전송에 실패했습니다.");
    }
  }

  // 이미지 설명 요청
  static async translate(text) {
    console.log(text);
    try {
      const formData = new FormData();
      formData.append("text", text);
      //formData.append('request_id', cachedUuid);
      const response = await apiClient.post("/translate", formData);
      console.log("translate response:", response.data);
      return response.data;
    } catch (error) {
      console.error("translate 실패 상세:", {
        status: error?.response?.status,
        data: error?.response?.data, // 🔴 여기! 검증 오류 목록 확인
        message: error?.message,
      });
      throw new Error("translate 분석에 실패했습니다.");
    }
  }

  // STEM 교육 콘텐츠 생성 요청
  static async generateStemContent(
    imageId,
    subject = null,
    difficulty = "medium",
  ) {
    try {
      const payload = {
        image_id: imageId,
        subject: subject,
        difficulty: difficulty,
      };

      const response = await apiClient.post("/stem-content", payload);
      return response.data;
    } catch (error) {
      throw new Error("STEM 콘텐츠 생성에 실패했습니다.");
    }
  }

  // 대화 기록 조회
  static async getConversationHistory(conversationId) {
    try {
      const response = await apiClient.get(`/conversations/${conversationId}`);
      return response.data;
    } catch (error) {
      throw new Error("대화 기록을 불러오는데 실패했습니다.");
    }
  }
}

export default ApiService;
